var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog"},[_c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.show,"width":_vm.width},on:{"update:visible":function($event){_vm.show=$event},"close":_vm.close}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }